/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/

var api_canvas = [ null, null, null, null ];
var api_context = [ null, null, null, null ];

var UI = new control_area(null, null, null, null);
var apiDir = '/scripts/pixelfield/';
if(typeof(__dirname) != "undefined"){
	console.log("apiDir: " +  __dirname);
	apiDir = __dirname+'/';
}

var col_UI_orange = null;
var col_UI_blue = null;
var col_UI_gray = null;
var col_UI_gray_arrow = null;
var col_UI_grad_blue = null;
var col_UI_grad_gray = null;
var col_UI_grad_orange = null;

//

function dim_apply()
{
	dim_new = 0;
	dim_wid = dim_api_wid;
	dim_hei = dim_api_hei;
	if (!dim_wid || !dim_hei) return;
	if (dim_wid > dim_hei)
		dim_proj = dim_wid;
	else
		dim_proj = dim_hei;

	if (api_dim_callback != null)
	{
		api_dim_callback(0, null);
		api_dim_callback = null;
	}
	UI.refresh_range_proportions(dim_wid, dim_hei);
}

	function set_filter_image(img, api, callback)
	{
		image = img;
		image_ready = 0;
		image_drop = 1;


		var wid, hei;

		wid = image.width;
		hei = image.height;

		if (wid > hei)
		{
			x_res = Math.floor(wid/hei*dim_bmp);
			y_res = dim_bmp;
		}
		else
		{
			x_res = dim_bmp;
			y_res = Math.floor(hei/wid*dim_bmp);
		}

		img_x_res = x_res;
		img_y_res = y_res;

		x_res = dim_bmp; y_res = dim_bmp;
		grab_image();

		if (api && callback != null) callback(0, null);
		//undo_clear();
	}

//

if (typeof pf_nodejs === "undefined")
{

	var worker1 = [ new Worker(apiDir + 'filter.js'), new Worker(apiDir + 'filter.js') ];
	worker1[0].postMessage({cmd:"start", pos:0});
	worker1[1].postMessage({cmd:"start", pos:1});

	var worker2 = [ new Worker(apiDir + 'filter.js'), new Worker(apiDir + 'filter.js') ];
	worker2[0].postMessage({cmd:"start", pos:0});
	worker2[1].postMessage({cmd:"start", pos:1});
}
else
{
	var worker1 = [ new Worker(apiDir + 'filter.js'), new Worker(apiDir + 'filter.js') ];
	worker1[0].postMessage({cmd:"start", pos:0});
	worker1[1].postMessage({cmd:"start", pos:1});

	var worker2 = [ new Worker(apiDir + 'filter.js'), new Worker(apiDir + 'filter.js') ];
	worker2[0].postMessage({cmd:"start", pos:0});
	worker2[1].postMessage({cmd:"start", pos:1});
}

//

var vectors_l1 = [ new Array(), new Array() ];
var vectors_l2 = [ new Array(), new Array() ];
var worker_done = [ 1, 1 ];
var worker_got = [ 0, 0 ];
var worker_paint = [ 0, 0 ];
var worker_start = [ -1, -1 ];
var worker_detail = 0;
var worker_paint_steps = [ [ 0, 0 ], [ 0, 0 ] ], worker_paint_step = [ [ 0, 0 ], [ 0, 0] ];
var worker_paint_start = [ 0, 0 ];
var worker_full_pending = 1;
var worker_full_pending_time = 0;

	function worker_get(e)
	{
		if (e.data.layer == -1)
		{
			image_ready++;
			return;
		}

		var pos = e.data.pos;
		switch (e.data.layer)
		{
			case 0: vectors_l1[pos] = vectors_l1[pos].concat(e.data.out); break;
			case 1: vectors_l2[pos] = vectors_l2[pos].concat(e.data.out); break;
		}

		if (e.data.done)
			worker_got[pos]++;
		if (worker_got[pos] == 2)
		{
			worker_got[pos] = 0;
			worker_done[pos] = 1;
			worker_paint[pos] = 1;
			worker_paint_steps[pos][0] = Math.floor((vectors_l1[pos].length)/5000) + 1;
			worker_paint_steps[pos][1] = Math.floor((vectors_l2[pos].length)/5000) + 1;
			worker_paint_step[pos][0] = 0; worker_paint_step[pos][1] = 0;
			worker_paint_start[pos] = 1;

			if (typeof pf_nodejs === "undefined") // no nodejs
			{
				if (image_ready == 4 && val_change && worker_done[1] && !worker_paint[1] && !image_saving.saving)
				{
					new_frame(1);
				}

				if (pos == 0 && api_donefx_callback != null) api_donefx_callback(0);
			}
			else
			{
				if (api_donefx_callback != null) api_donefx_callback(0);
			}
		}
	}


//
if (typeof pf_nodejs === "undefined" || pf_nodejs_mth == 1)
{
	worker1[0].addEventListener('message', worker_get);
	worker2[0].addEventListener('message', worker_get);
	//if (typeof pf_nodejs === "undefined") used for slicing in nodejs
	//{
		worker1[1].addEventListener('message', worker_get);
		worker2[1].addEventListener('message', worker_get);
	//}
}

//

	function web_animate()
	{
		var a, v, c, b, l;

		if (time_start == -1)
		{
			time_start = (new Date()).getTime();
		}
		var date = new Date();
		time = date.getTime() - time_start;
/*
		if (image_drop)
		{
			fxlist_generate_thumbs();
			image_drop = 0;
		}

		if (fx_thumbs_ready & fx_thumbs_refresh)
		{
			fxlist_paint();
			fx_thumbs_refresh = 0;
		}
		if (ui_refresh)
		{
			UI.paint_refresh();
			ui_refresh = 0;
		}
*/
		if (image_saving.saving)
		{
			save_layers_progress();
		}

		if (worker_paint[1])
		{
			paint_views(1);
		}

		if (worker_paint[0])
		{
			paint_views(0);
		}
		/*
		else
		{
			if (worker_start[0] != -1)
			{
				var t = (new Date()).getTime();
				t -= worker_start[0];
				if (t > 50)
				{
					t = Math.floor(t / 50);
					for (var a = 0; a < t; a++)
					{
						rect(context[2], 20+(a % 53)*12, 20+Math.floor(a/53)*7, 10, 5, FILL, col_white, 1);
						rect(context[3], 20+(a % 53)*12, 20+Math.floor(a/53)*7, 10, 5, FILL, col_white, 1);
					}
				}
			}
		}
*/
/*
		if (worker_done[0] && grab_image_req && image_ready == 4)
		{
			grab_image();
			grab_image_req = 0;
		}
*/
		if (image_ready == 4 && val_change && /*(time - val_change_time) > 20 &&*/ worker_done[1] /*&& !worker_paint[1]*/ && !image_saving.saving)
		{
			new_frame(1);
		}
		if (image_ready == 4 && !val_change && api_detail_request && worker_done[1] && !image_saving.saving)
		{
			api_detail_request = 0;
			new_detail();
		}
		if (image_ready == 4 && worker_full_pending && (time - worker_full_pending_time) > 0 && worker_done[0] /*&& !worker_paint[0]*/ && !image_saving.saving)
		{
			new_frame(0);
		}
		web_anim_do();
	}
